import { render } from "./Repay.vue?vue&type=template&id=2b8f5d84"
import script from "./Repay.vue?vue&type=script&lang=js"
export * from "./Repay.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/ab-front-library/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__